import { State } from './splashtech-duck';
import createSliceSelector from '../../../utils/create-slice-selector';

const selectSplashtechState = createSliceSelector<State>('splashtech');
export default selectSplashtechState;
